import {ConnecttocrudService} from '../../connecttocrud.service';
import {Item} from '../../item';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {ConfService} from '../../conf.service';
import {MatButtonToggleChange, MatTreeNestedDataSource} from '@angular/material';
import {NestedTreeControl} from '@angular/cdk/tree';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {AppComponent} from '../../app.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

declare let $;


@Component({
    selector: 'app-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.css']
})
export class AddComponent implements OnInit {
    id: string;
    item: Item = {} as Item;
    columns: string[] = [];
    partner: string;
    account: string;
    entity: string;
    version: string;
    partnerKey: string;
    attributes: any;
    userView = 'json';
    dataModel: any;
    treeControl = new NestedTreeControl<any>(node => node.subType);
    dataSource = new MatTreeNestedDataSource<any>();
    options1 = new JsonEditorOptions();
    metadata: any;
    datatypes: any;
    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    previousUserView = '';
    editorData: any;
    loading = false;

    constructor(private _service: ConnecttocrudService,
                private location: Location,
                private route: ActivatedRoute,
                private confPost: ConfService,
                private appComp: AppComponent,
                public platform: LeftpanelComponent) {
        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log(/*this.editor.get()*/);
    }

    hasChild = (_: number, node: any) => !!node.subType && node.subType.length > 0;

    setcolumnvalues(): any {
        this.confPost.getEntity(this.partner, this.account, this.entity, this.version).subscribe(items => {
            this.metadata = items;
            this.dataSource.data = this.metadata.attributes;
            this.getDataModel();
        });
    }

    toggleOnConfirmation(change: MatButtonToggleChange) {
        if (confirm('Changing the view will wipe out the existing data designed to insert. Do you still want to continue?')) {
            this.userView = change.value;
            this.previousUserView = this.userView;
        } else {
            this.userView = this.previousUserView;
            if (change.value === 'table') {
                change.source.tabIndex = 0;
            } else {
                change.source.tabIndex = 1;
            }
        }
    }

    getLeaf(event) {
        const leafArray = [];
        const leafObj = {};
        $(event).children('li').children('ul').children('mat-tree-node').each(function () {
            leafObj[$(this).find('li').find('table').find('tr td:eq(0)').text()] =
                $(this).find('li').find('table').find('tr td:eq(1) input').val();
        });
        leafArray.push(leafObj);
        return leafArray;
    }

    treeNode(event) {
        const that = this;
        const nestedTree = [];
        const parentObj = {};
        $(event).children('mat-nested-tree-node').each(function () {
            let nested, leaf;
            parentObj[$(this).children('li').children('div').find('td').text()] = [];
            if ($(this).children('li').children('ul').children('mat-nested-tree-node').length > 0) {
                nested = that.treeNode($(this).children('li').children('ul'));
            }
            if ($(this).children('li').children('ul').children('mat-tree-node').length > 0) {
                leaf = that.getLeaf($(this));
            }
            parentObj[$(this).children('li').children('div').find('td').text()].push(Object.assign((nested ? nested[0] : {}), (leaf ? leaf[0] : {})));
            nestedTree.push(parentObj);
        });
        return nestedTree;
    }

    saveData(): void {
        this.loading = true;
        const that = this;
        const parent = [];
        const parentObj = {};
        $('mat-tree').children('mat-tree-node').each(function () {
            parentObj[$(this).find('li').find('table').find('tr td:eq(0)').text()] =
                $(this).find('li').find('table').find('tr td:eq(1) input').val();
        });
        $('mat-tree').children('mat-nested-tree-node').each(function () {
            let nested, leaf;
            parentObj[$(this).children('li').children('div').find('td').text()] = [];
            if ($(this).children('li').children('ul').children('mat-nested-tree-node').length > 0) {
                nested = that.treeNode($(this).children('li').children('ul'));
            }
            if ($(this).children('li').children('ul').children('mat-tree-node').length > 0) {
                leaf = that.getLeaf($(this));
            }
            parentObj[$(this).children('li').children('div').find('td').text()].push(Object.assign((nested ? nested[0] : {}), (leaf ? leaf[0] : {})));
        });
        parent.push(parentObj);
        this._service.addItem(parent[0], this.version, this.partner, this.account, this.entity).subscribe(
            status => {
                this.loading = false;
                this.platform.openSnackBar('Data Added successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            },
            error => {
                this.loading = false;
                this.platform.openSnackBar('Something went wrong. Please try after sometime', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        );
    }
    stringifyjson(val) {
        return JSON.stringify(val);
    }
    getSubType(data, event) {
        const that = this;
        const trs = [];
        data.forEach((value) => {
            let tr;
            if (value.subType == null) {
                tr = $('<tr><td>' + value.displayName + '</td><td><input class="form-control" type="text"></td></tr>');
            } else {
                tr = $('<td>' + value.displayName + '</td> <td><i class="fa fa-arrow-circle-down"></i></td>');
            }
            if (value.subType != null) {
                $(tr).find('i').click(function (event1) {
                    that.getSubType(value.subType, event1);
                });
            }
            trs.push(tr);
        });
        $(event.target).closest('td').after(trs);
        $(event.target).closest('td').remove();
    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.previousUserView = this.userView;
        this.appComp.currentPageTitle = 'Insert Record';
        this.route.queryParams
            .subscribe(params => {
                this.partner = params.partner;
                this.account = params.account;
                this.entity = params.entity;
                this.version = params.version;
                this.partnerKey = localStorage.getItem('partnerKey');
            });
        if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
            this.datatypes = this.platform.datatypes;
        } else {
            await this.confPost.getDataTypes().toPromise().then(data => {
                    this.datatypes = data;
                    this.platform.datatypes = data;
                },
                error => {
                this.platform.handleErrorGracefully(error, 'Error while getting list of data types.');
                    // this.platform.openSnackBar('Error while getting list of data types: ' + error.error.message, 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                });
        }
        this.setcolumnvalues();
    }

    getDataModel() {
        this.dataModel = {};
        const that = this;
        this.dataSource.data.forEach((data) => {
            // if (data.array === true && data.type === 'Integer') {
            //     this.dataModel[data.attributeName] = ['ArrayOfNumbers'];
            // } else if (data.array === true && data.type === 'String') {
            //     this.dataModel[data.attributeName] = ['ArrayOfStrings'];
            //
            if ( data.array === true ) {
                if ( data.type === 'Object') {
                    this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
                } else {
                    if (data.type.includes('_')) {
                        this.dataModel[data.attributeName] = [data.type + ' (id)'];
                    } else {
                        this.dataModel[data.attributeName] = [data.type];
                    }
                }
            } else if (data.type === 'Object') {
                this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
                if (this.dataModel[data.attributeName][0] !== null && this.dataModel[data.attributeName][0] !== undefined && this.dataModel[data.attributeName][0] !== '') {
                    this.dataModel[data.attributeName] = this.dataModel[data.attributeName][0];
                } else {
                    this.dataModel[data.attributeName] = {};
                }
            } else if (data.type !== 'Array' && data.type !== 'Object' && data.type !== 'Array Of Strings' && data.type !== 'Array Of Numbers' && data.type !== 'Integer' && data.type !== 'Boolean' && !(data.type.includes('_'))) {
                this.dataModel[data.attributeName] = data.type;
            // } else if (data.type === 'Array Of Strings' || data.type === 'Array Of Numbers') {
            //     this.dataModel[data.attributeName] = [];
            } else if (data.type === 'Integer') {
                this.dataModel[data.attributeName] = 0;
            } else if (data.type === 'Boolean') {
                this.dataModel[data.attributeName] = false;
            } else if (data.type.includes('_')) {
                this.dataModel[data.attributeName] = data.type + ' (id)';
            }
            this.datatypes.forEach(type => {
                if (type && type !== undefined && type !== null) {
                    if (type['data_types'][0]['type'] === data.type) {
                        if (type['data_types'][0]['family'] === 'Number') {
                            this.dataModel[data.attributeName] = 0;
                        } else if (type['data_types'][0]['family'] === 'Boolean') {
                            this.dataModel[data.attributeName] = false;
                        }  else if (type['data_types'][0]['family'] === 'Decimal') {
                            this.dataModel[data.attributeName] = 0;
                        }
                    }
                }
            });
        });
        return this.dataModel;
    }

    getSub(data) {
        const subType = [];
        const obj = {};
        const that = this;
        if (data.length > 0) {
            data.forEach((result) => {
                if ( result.array === true ) {
                    if ( result.type === 'Object') {
                        obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
                    } else {
                        if (result.type.includes('_')) {
                            obj[result.attributeName] = [result.type + ' (id)'];
                        } else {
                            obj[result.attributeName] = [result.type];
                        }                    }
                } else if (result.type === 'Object') {
                    obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
                    obj[result.attributeName] = obj[result.attributeName][0];
                    if (obj[result.attributeName] && obj[result.attributeName].length > 0 && obj[result.attributeName][0] !== null && obj[result.attributeName][0] !== undefined && obj[result.attributeName][0] !== '') {
                        obj[result.attributeName] = obj[result.attributeName][0];
                    } else {
                        obj[result.attributeName] = {};
                    }

                } else if (result.type !== 'Array' && result.type !== 'Object' && result.type !== 'Array Of Strings' && result.type !== 'Array Of Numbers' && result.type !== 'Integer' && result.type !== 'Boolean' && !(result.type.includes('_'))) {
                    obj[result.attributeName] = result.type;
                    // } else if (result.type === 'Array Of Strings' || result.type === 'Array Of Numbers') {
                    //     obj[result.attributeName] = [];
                } else if (result.type === 'Integer') {
                    obj[result.attributeName] = 0;
                } else if (result.type === 'Boolean') {
                    obj[result.attributeName] = false;
                } else if (result.type.includes('_')) {
                    obj[result.attributeName] = result.type + ' (id)';
                }
                this.datatypes.forEach(type => {
                    if (type && type !== undefined && type !== null) {
                        if (type['data_types'][0]['type'] === data.type) {
                            if (type['data_types'][0]['family'] === 'Number') {
                                obj[result.attributeName] = 0;
                            } else if (type['data_types'][0]['family'] === 'Boolean') {
                                obj[result.attributeName] = false;
                            }  else if (type['data_types'][0]['family'] === 'Decimal') {
                                obj[result.attributeName] = 0;
                            }
                        }
                    }
                });

                // if (result.array === true && result.type === 'Integer') {
                //     obj[result.attributeName] = ['ArrayOfNumbers'];
                // } else if (result.type != 'Array' && result.type != 'Object' && result.type != 'Array Of Strings' && result.type != 'Array Of Numbers' && result.type != 'Integer' && result.type != 'Boolean') {
                //     obj[result.attributeName] = result.type;
                // } else if (result.type === 'Array' || result.type === 'Object'){
                //     obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
                // } else if (result.type === 'Array Of Strings' || result.type === 'Array Of Numbers') {
                //     obj[result.attributeName] = [];
                // } else if (result.type === 'Integer') {
                //     obj[result.attributeName] = 0;
                // } else if (result.type === 'Boolean') {
                //     obj[result.attributeName] = false;
                // }
            });
            subType.push(obj);
        }
        return subType;
    }

    getEditorData() {
        return new Promise((resolve, reject) => {
            try {
                this.editorData = this.editor.get();
                resolve('success');
            } catch (e) {
                reject(e);
            }
        });
    }

    async saveJSONData() {
        this.loading = true;
        await Promise.resolve(this.getEditorData()).then(resp => {
                this._service.addItem(this.editorData, this.version, this.partner, this.account, this.entity).subscribe(
                    status => {
                        this.loading = false;
                        this.platform.openSnackBar('Data Added successfully', 'Success', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    },
                    error => {
                        this.loading = false;
                        this.platform.handleErrorGracefully(error, 'Something went wrong. Please try after sometime.');
                    }
                );
        }, error => {
            this.loading = false;
            this.platform.openSnackBar(error, 'Error', {
                duration: 60000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

}
